import { getSidebarItems } from '../containers/App/components/Sidebar';
import { store } from './store';

export function getPagesForUser() {
  const userId = store?.getState()?.auth?.id;
  const sidebarItems = getSidebarItems(userId);
  const allItems = sidebarItems.concat(sidebarItems.flatMap((item) => item.children || []));
  return allItems?.map((item) => item.to).filter((to) => to);
}

export function getDefaultPageForUser() {
  const userId = store?.getState()?.auth?.id;
  const menuItems = getSidebarItems(userId);
  return menuItems[0]?.to || '/';
}